import { render, staticRenderFns } from "./sidebarAggregator.vue?vue&type=template&id=27839ee2&"
import script from "./sidebarAggregator.vue?vue&type=script&lang=js&"
export * from "./sidebarAggregator.vue?vue&type=script&lang=js&"
import style0 from "./sidebarAggregator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports